import React, { useEffect, useMemo, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Modal,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  CircularProgress,
  InputAdornment,
  FormControl,
  InputLabel,
  IconButton,
  Divider,
} from "@mui/material";
import {
  getMarketResearchProduct,
  getProductList,
  getScannedDocuments,
  removeProductMapping,
  submitProductMapping,
  webscrappingTyreData,
} from "_controllers/officer";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Toaster } from "react-hot-toast";
import { toastMessage } from "utils/toastMessage";
import authAxios from "setups/axios";
import { useDispatch, useSelector } from "react-redux";
import { fetchOfficersList } from "slices/officers";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import AttachmentIcon from "@mui/icons-material/Attachment";
import CloseIcon from "@mui/icons-material/Close";
import SyncIcon from "@mui/icons-material/Sync";
import axios from "axios";
import { schemeConstants } from "config/constants";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import * as XLSX from "xlsx";
import writeXlsxFile from "write-excel-file";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import exportExcel from "utils/excelGenerate";
import { PageHeader, SectionCard, EmptyState, TablePager } from "_shared/ui";

// Slide-over panel used by the "Sync Product" modal.
const messageStyle = {
  position: "fixed",
  top: 0,
  right: 0,
  height: "100vh",
  width: { xs: "100%", sm: "60%", md: "35%" },
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  pt: 2,
  pb: 0,
  pl: 4,
  pr: 4,
  textAlign: "left",
  letterSpacing: 1,
};

// Centered dialog used by the comparison / matching modals.
const messageStyle1 = {
  position: "absolute",
  top: "50%",
  width: { xs: "95%", md: "75%" },
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  pt: 2,
  pb: 2,
  pl: 4,
  pr: 4,
  textAlign: "left",
  letterSpacing: 1,
};

const brandList = ["MRF", "CEAT", "APOLLO", "TYRE-DEKHO"];
const category = ["CAR", "TRUCK", "2/3W", "FARM", "JEEP"];
const category1 = ["MRF", "CEAT", "APOLLO"];
const tyreCategoryList = ["SCV", "Car", "LCV", "TRUCK", "FARM", "2/3W"];

// Header row for the modal product cards. Shared by comparison & matching.
const ProductCard = ({ product, idx, action }) => (
  <Paper
    variant="outlined"
    sx={{
      p: 2,
      display: "flex",
      justifyContent: "space-between",
      gap: 2,
      boxShadow: 2,
      mt: idx > 0 ? 2 : 0,
    }}
  >
    <Box
      sx={{
        textDecoration: product?.matched ? "line-through" : "none",
      }}
    >
      <Typography variant="body1" sx={{ fontWeight: 600 }}>
        {product?.productName} ({product?.companyName})
      </Typography>
      <Typography variant="body2" color="text.secondary">
        ₹ {product?.productPrice}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {product?.productSize}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {product?.productDescription}
      </Typography>
    </Box>
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
      }}
    >
      <Box
        component="img"
        src={product?.productImage}
        alt={product?.companyName}
        sx={{ width: 50 }}
      />
      {action}
    </Box>
  </Paper>
);

const Main = () => {
  const [data, setData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [image, setImage] = useState("");

  const [schemeData, setSchemeData] = useState();

  const [categories, setCategories] = useState([]);
  const [spendLimit, setSpendLimit] = useState([]);

  const [openModal, setOpenModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [search, setSearch] = useState("");
  const [role, setRole] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");

  const [syncBrand, setSyncBrand] = useState("");
  const [syncCategory, setSyncCategory] = useState("");

  const [comparisonData, setComparisonData] = useState();
  const [openComparisonModal, setOpenComparisonModal] = useState(false);
  const [selectedTyre, setSelectedTyre] = useState("");

  const [matchedData, setMatchedData] = useState();
  const [openMatchingModal, setOpenMatchingModal] = useState(false);

  const [materiallist, setMateriallist] = useState([]);
  const [searchProduct, setSearchProduct] = useState("");
  const [selectedMaterial, setSelectedMaterial] = useState("");

  const [syncErr, setsyncErr] = useState({
    brand: false,
    category: false,
  });

  let columns = useMemo(() => [
    {
      headerName: "Brand Name",
      flex: 1,
    },
    {
      headerName: "Category",
      flex: 1,
    },
    {
      headerName: "Price",
      flex: 2,
    },
    {
      headerName: "Size",
      flex: 1,
    },
    {
      headerName: "Mapped",
      flex: 1,
    },
    {
      headerName: "Scrapped",
      flex: 1,
    },
    // {
    //   headerName: "Action",
    //   flex: 1,
    // },
  ]);

  const Validate = () => {
    let value = true;
    let err = {};

    if (syncBrand === "") {
      err.brand = "Please Select Brand.";
      value = false;
    }

    if (syncCategory === "") {
      err.category = "Please Select Category.";
      value = false;
    }
    setsyncErr({ ...err });
    return value;
  };

  useEffect(async () => {
    const survey = await getMarketResearchProduct({
      currentPage,
      search,
      filter: selectedBrand,
    });
    setData(survey?.data);
    setCsvData(survey?.csvdata);
    setMessage(survey?.message);
    setLoading(true);
    setTotalPages(survey?.totalPage ?? 1);
  }, [message, currentPage, search, selectedBrand]);

  useEffect(async () => {
    const products = await getProductList({
      search: searchProduct,
    });
    setMateriallist(products?.data);
    setMessage(products?.message);
  }, [searchProduct]);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    let updatedCategories = categories.map((category) => {
      let roSpendLimit = spendLimit.find((obj) => obj.role === role);
      if (roSpendLimit) {
        let updatedSubCategory = category.subCategory.map((subCategory) => {
          let matchedSubCategory = roSpendLimit.spendLimit
            .find((s) => s.category === category._id)
            ?.subCategory.find((sub) => sub.subCategory === subCategory._id);
          if (matchedSubCategory) {
            return { ...subCategory, amount: matchedSubCategory.amount };
          }
          return subCategory;
        });
        return { ...category, subCategory: updatedSubCategory };
      }
      return category;
    });
    setCategories(updatedCategories);
  }, [role]);

  const handleSyncSubmit = async () => {
    if (Validate()) {
      console.log("inside");
      await webscrappingTyreData({
        syncBrand,
        syncCategory,
      })
        .then((res) => {
          setMessage(res?.message);
          toastMessage(res?.message, "success");
          setSyncBrand("");
          setSyncCategory("");
          setOpenModal(false);
        })
        .catch((err) => {
          setMessage(err?.message);
          toastMessage(err?.message, "error");
          setSyncBrand("");
          setSyncCategory("");
          setOpenModal(false);
        });
    } else {
      setsyncErr({
        brand: true,
        category: true,
      });
    }
  };

  const handleSubmitMapping = async () => {
    // if (Validate()) {
    await submitProductMapping({
      selectedTyre,
      selectedMaterial,
    })
      .then((res) => {
        setMessage(res?.message);
        toastMessage(res?.message, "success");
        setOpenComparisonModal(false);
      })
      .catch((err) => {
        setMessage(err?.message);
        toastMessage(err?.message, "error");
        setOpenComparisonModal(false);
      });
    // } else {
    // setsyncErr({
    //   brand: true,
    //   category: true,
    // });
    // }
  };
  const handleRemove = async (product, materialno) => {
    await removeProductMapping({
      product,
      materialno,
    })
      .then((res) => {
        setMessage(res?.message);
        toastMessage(res?.message, "success");
        setOpenMatchingModal(false);
      })
      .catch((err) => {
        setMessage(err?.message);
        toastMessage(err?.message, "error");
        setOpenMatchingModal(false);
      });
  };

  const generateExcel = async (e) => {
    e.preventDefault();
    let fileName = "Product Mapping";
    exportExcel(
      csvData.map((x) => {
        let scrappedProduct = {};
        x?.allProducts && x?.allProducts.length > 0
          ? x?.allProducts.map((item, idx) => {
              scrappedProduct[`Company ${idx + 1}`] = item.companyName;
              scrappedProduct[`Product Name ${idx + 1}`] = item.productName;
              scrappedProduct[`Product Size ${idx + 1}`] = item.productSize;
              scrappedProduct[`Product Price ${idx + 1}`] =
                item.productPrice ?? 0;
              scrappedProduct[`Product Description ${idx + 1}`] =
                item.productDescription;
            })
          : null;

        let mappedProduct = {};
        x?.matchedProducts && x?.matchedProducts.length > 0
          ? x?.matchedProducts.map((item, idx) => {
              mappedProduct[`Company ${idx + 1}`] = item.companyName;
              mappedProduct[`Product Name ${idx + 1}`] = item.productName;
              mappedProduct[`Product Size ${idx + 1}`] = item.productSize;
              mappedProduct[`Product Price ${idx + 1}`] =
                item.productPrice ?? 0;
              mappedProduct[`Product Description ${idx + 1}`] =
                item.productDescription;
            })
          : null;

        return {
          "Material No": x?.materialNo,
          "Material Desc": x.productName,
          Category: x.tyreCategory,
          Size: x.productSize,
          Price: x.productPrice ?? 0,
          ...scrappedProduct,
          ...mappedProduct,
        };
      }),
      fileName
    );
  };

  return (
    <>
      <PageHeader
        title="Market Research"
        subtitle="Competitor tyre pricing and product mapping"
        action={
          <>
            <Button
              variant="contained"
              startIcon={<SyncIcon />}
              onClick={() => setOpenModal(true)}
            >
              Sync Product
            </Button>
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              onClick={generateExcel}
            >
              Download
            </Button>
          </>
        }
      />

      <Paper
        sx={{
          p: 2,
          mb: 2.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <TextField
          onChange={(e) => setSearch(e.target.value)}
          value={search}
          name="search"
          label="Search by SKU"
          size="small"
          sx={{ width: { xs: "100%", sm: 300 } }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
        <FormControl sx={{ minWidth: 220 }} size="small">
          <InputLabel id="zone-label">Filter by Product Type</InputLabel>
          <Select
            labelId="zone-label"
            value={selectedBrand}
            name="selectedBrand"
            label="Filter by Product Type"
            fullWidth
            size="small"
            onChange={(event) => setSelectedBrand(event.target.value)}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {tyreCategoryList?.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Paper>

      <SectionCard disablePadding>
        {loading ? (
          <>
            <TableContainer
              sx={{
                maxHeight: "58vh",
                overflowY: "auto",
              }}
            >
              <Table stickyHeader>
                {columns && columns.length > 0 ? (
                  <TableHead>
                    <TableRow>
                      {columns.map((item, idx) => (
                        <TableCell
                          align={idx === 0 ? "left" : "center"}
                          key={idx}
                        >
                          {item.headerName}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                ) : null}

                <TableBody>
                  {data && data?.length > 0 ? (
                    data?.map((d) => (
                      <TableRow key={d?._id}>
                        <TableCell align="left">{d?.productName}</TableCell>
                        <TableCell align="center">{d?.tyreCategory}</TableCell>
                        <TableCell align="center">
                          ₹ {d?.productPrice ? d?.productPrice : 0}
                        </TableCell>
                        <TableCell align="center">{d?.tyreSize}</TableCell>
                        <TableCell align="center">
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => {
                              setOpenMatchingModal(true);
                              setMatchedData(d);
                            }}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </TableCell>
                        <TableCell align="center">
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => {
                              setOpenComparisonModal(true);
                              setComparisonData(d?.allProducts);
                            }}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={columns.length} sx={{ border: 0 }}>
                        <EmptyState
                          title="No data"
                          description="No market research products found for the current filters."
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Divider />
            <TablePager
              totalPages={totalPages}
              page={currentPage}
              onPageChange={(p) => handlePageChange(null, p)}
            />
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 8,
            }}
          >
            <CircularProgress />
          </Box>
        )}
      </SectionCard>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box sx={messageStyle}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pb: 1,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Sync Product
            </Typography>
            <IconButton color="error" onClick={() => setOpenModal(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <div>
            <Typography sx={{ mt: 2.5, fontSize: "16px" }}>
              Brand Name
            </Typography>
            <TextField
              select
              name="syncBrand"
              value={syncBrand}
              onChange={(e) => setSyncBrand(e.target.value)}
              label="Select an Option"
              fullWidth
              sx={{ mt: 1.25 }}
              error={syncErr.brand}
              helperText={syncErr.brand}
            >
              {brandList.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>

            <Typography sx={{ mt: 2.5, fontSize: "16px" }}>Category</Typography>
            <TextField
              select
              name="syncCategory"
              value={syncCategory}
              onChange={(e) => setSyncCategory(e.target.value)}
              label="Select an Option"
              fullWidth
              sx={{ mt: 1.25 }}
              error={syncErr.category}
              helperText={syncErr.category}
            >
              {syncBrand === "TYRE-DEKHO"
                ? category1.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))
                : category.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
            </TextField>

            <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
              <Button variant="contained" onClick={() => handleSyncSubmit()}>
                Sync
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={() => {
                  setSyncBrand("");
                  setSyncCategory("");
                }}
              >
                Discard
              </Button>
            </Stack>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openComparisonModal}
        onClose={() => setOpenComparisonModal(false)}
      >
        <Box sx={messageStyle1}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pb: 1,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Market Research Products
            </Typography>
            <IconButton
              color="error"
              onClick={() => setOpenComparisonModal(false)}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              py: 2,
              display: "flex",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: "49%",
                border: 1,
                borderColor: "divider",
              }}
            >
              <Box
                sx={{
                  p: 2,
                  maxHeight: "70vh",
                  overflowY: "auto",
                }}
              >
                {comparisonData && comparisonData.length > 0
                  ? comparisonData.map((product, idx) => (
                      <ProductCard
                        key={idx}
                        product={product}
                        idx={idx}
                        action={
                          <Button
                            size="small"
                            variant="contained"
                            sx={{ fontSize: "12px" }}
                            disabled={
                              selectedTyre?.productName ===
                                product?.productName &&
                              selectedTyre?.productPrice ===
                                product?.productPrice
                                ? true
                                : false
                            }
                            onClick={() => setSelectedTyre(product)}
                          >
                            SELECT
                          </Button>
                        }
                      />
                    ))
                  : null}
              </Box>
            </Box>
            <Box
              sx={{
                width: "49%",
                border: 1,
                borderColor: "divider",
                p: 2,
              }}
            >
              <TextField
                id="standard-basic"
                value={
                  selectedTyre !== undefined ? selectedTyre?.productName : ""
                }
                variant="outlined"
                disabled="true"
                fullWidth
              />
              <Typography sx={{ textAlign: "center", my: 2 }}>V/S</Typography>
              <Autocomplete
                id="tags-outlined"
                options={materiallist}
                getOptionLabel={(option) => `${option?.matDesc}`}
                onChange={(event, newValue) =>
                  setSelectedMaterial(newValue?.matnr)
                }
                sx={{ width: "100%", mt: 2 }}
                renderInput={(params) => (
                  <>
                    <TextField
                      {...params}
                      variant="outlined"
                      label={"Select Material SKU"}
                      placeholder="Material No"
                      onChange={(e) => setSearchProduct(e.target.value)}
                    />
                  </>
                )}
              />

              <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                <Button
                  variant="contained"
                  disabled={selectedTyre === undefined ? true : false}
                  onClick={() => handleSubmitMapping()}
                >
                  SUBMIT
                </Button>
                <Button
                  variant="outlined"
                  color="inherit"
                  disabled={selectedTyre === undefined ? true : false}
                  onClick={() => {
                    setSelectedTyre();
                    console.log("inside1");
                  }}
                >
                  CANCEL
                </Button>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openMatchingModal}
        onClose={() => setOpenMatchingModal(false)}
      >
        <Box sx={messageStyle1}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pb: 1,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Products Mapped With JK Tyre
            </Typography>
            <IconButton
              color="error"
              onClick={() => setOpenMatchingModal(false)}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              border: 1,
              borderColor: "divider",
              mt: 2,
            }}
          >
            <Box
              sx={{
                p: 2,
                maxHeight: "70vh",
                overflowY: "auto",
              }}
            >
              {matchedData?.matchedProducts &&
              matchedData?.matchedProducts.length > 0
                ? matchedData?.matchedProducts.map((product, idx) => (
                    <ProductCard
                      key={idx}
                      product={product}
                      idx={idx}
                      action={
                        <Button
                          size="small"
                          variant="contained"
                          color="error"
                          sx={{ fontSize: "12px" }}
                          disabled={
                            selectedTyre?.productName === product?.productName &&
                            selectedTyre?.productPrice === product?.productPrice
                              ? true
                              : false
                          }
                          onClick={() =>
                            handleRemove(product, matchedData?.materialNo)
                          }
                        >
                          REMOVE
                        </Button>
                      }
                    />
                  ))
                : null}
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

const MarketResearch = () => {
  return (
    <AccessController roles={["ADMIN", "AO"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default MarketResearch;
